import React, { useEffect } from 'react';
import PodcastSection from '../components/ai-video/PodcastSection';
import VideoProcess from '../components/ai-video/VideoProcess';
import ContactCTA from '../components/ContactCTA';

const PodcastService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "AI Podcast Creation | Professional Cloned Audio & Video | DigitalGigs";
  }, []);

  return (
    <div className="bg-white pt-20">
      <PodcastSection isPageTitle />
      <div className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">Why AI Podcasts?</h2>
          <p className="text-slate-600 max-w-2xl mx-auto font-medium">
            Traditional podcasting requires hours of editing, expensive equipment, and physical availability. 
            AI podcasting allows you to scale your voice and influence 10x faster with 100x less effort.
          </p>
        </div>
      </div>
      <VideoProcess />
      <ContactCTA />
    </div>
  );
};

export default PodcastService;
